import React, { useState } from "react";
import "../../Styles/blog.css";
import { FaAngleRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Blog = ({ blog }) => {
  const navigate = useNavigate();
  console.log("blog", blog);

  return (
    <>
      <section className="blog-section">
        <div className="container">
          <div className="row">
            <div className="col-12 property-heading-col">
              <h3>Our Blog</h3>
              <a
                onClick={() => navigate("/blogs")}
                style={{ cursor: "pointer" }}
              >
                <h5>
                  Explore All
                  <span>
                    <img src="/images/btn-arrow.png" alt="Arrow Icon" />
                  </span>
                </h5>
              </a>
            </div>
          </div>
          <div className="row featured-row">
            {blog &&
              blog?.length &&
              blog?.map((item, i) => {
                return (
                  <div key={i} className="col-md-4">
                    <div
                      className="blog-main"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(`/blog-detail/${item.slug}-${item.id}`)
                      }
                    >
                      <img
                        src={item.image || "/images/blog-img.png"}
                        alt="hand-icon"
                      />
                      <div className="blog-title">
                        <p>{item.title}</p>
                        {/* <h5>Aurora Apartments 3BHK</h5> */}
                        <button onClick={() => navigate("/blogs")}>
                          Read More
                          <span>
                            <FaAngleRight />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
